// removed by extract-text-webpack-plugin
module.exports = {"xsmall":"only screen and (min-width: 375px)","small":"only screen and (min-width: 481px)","medium":"only screen and (min-width: 768px)","large":"only screen and (min-width: 993px)","xlarge":"only screen and (min-width: 1201px)","retina":"(-webkit-min-device-pixel-ratio: 2)","statsContainer":"statsContainer-2TWNe","stats":"stats-2IZAZ","stat":"stat-3Aenj","statTitle":"statTitle-rA8oM","communityFooter":"communityFooter-2Sq1A","iconWrapper":"iconWrapper-Tk7BR","activityList":"activityList-3Pbiy","callToActionWrapper":"callToActionWrapper-1HwZY","byline":"byline-eis7h"};


//////////////////
// WEBPACK FOOTER
// ./src/components/yearInReview/2018/midyear/Community/_mid2018Community.css
// module id = 1294
// module chunks = 1